// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"endscreen_bgColor__cPoEc","goodjobImg":"endscreen_goodjobImg__XBwKp","wrapper":"endscreen_wrapper__3J3o7","feedback":"endscreen_feedback__1jGla"};